<app-navbar title="Historia">
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<app-history type="vehicles" [id]="id"></app-history>
